export default "__VITE_ASSET__BqCHIEP___"